export interface AppLanguage {
    code: string;
    label: string;
    nativeLabel: string;
    rtl?: boolean;
}

/** Major locales supported in the language selector. */
export const APP_LANGUAGES: AppLanguage[] = [
    { code: 'en', label: 'English', nativeLabel: 'English' },
    { code: 'es', label: 'Spanish', nativeLabel: 'Español' },
    { code: 'fr', label: 'French', nativeLabel: 'Français' },
    { code: 'de', label: 'German', nativeLabel: 'Deutsch' },
    { code: 'pt', label: 'Portuguese', nativeLabel: 'Português' },
    { code: 'it', label: 'Italian', nativeLabel: 'Italiano' },
    { code: 'ja', label: 'Japanese', nativeLabel: '日本語' },
    { code: 'zh', label: 'Chinese (Simplified)', nativeLabel: '简体中文' },
    { code: 'ko', label: 'Korean', nativeLabel: '한국어' },
    { code: 'ar', label: 'Arabic', nativeLabel: 'العربية', rtl: true },
    { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी' },
    { code: 'ru', label: 'Russian', nativeLabel: 'Русский' },
];

export const DEFAULT_LANGUAGE = 'en';

export const isRtlLanguage = (code: string): boolean =>
    APP_LANGUAGES.some((lang) => lang.code === code && lang.rtl);
